<template>
  <div>
    <div ref="modal" class="modal" role="dialog">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Next Approver Name</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <fbselectbox
              v-if="approverList.length>0"
              v-model="lapprover.approver_id"
              :fbvalue="lapprover.approver_id"
              fbhidelabel="true"
              fbreadonly="false"
              :isedit="true"
              :fboptions="approverList"
            />
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-primary"
              ref="confirmClick"
              data-dismiss="modal"
            >Confirm</button>
            <button type="button" class="btn btn-default" ref="close" data-dismiss="modal">Close</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import helper from "@/vueHelper";

export default {
  props: {
    approver: Object,
    approverList: {
      type: Array,
      default: []
    }
  },
  data() {
    return {
      open: false,
      lapprover: {}
    };
  },
  mounted() {
    this.lapprover = this.approver || {};
  },
  computed: {},
  methods: {
    showModal() {
      return new Promise((resolve, reject) => {
        helper.showModal(this.$refs.modal);
        $(this.$refs.confirmClick).click(() => {
          resolve(this.lapprover);
        });

        $(this.$refs.close).click(() => {
          this.lapprover.approver_id = null;
          resolve(false);
        });
        $(this.$refs.modal).on("hidden.bs.modal", () => {
          this.lapprover.approver_id = null;
          reject(false);
        });
      });
    }
  },
  watch: {
    approver(val) {
      this.lapprover = val || {};
    }
  }
};
</script>

<style>
</style>